import { jsx } from 'react/jsx-runtime';
import { EGDSText } from '@egds/react-core/text';
import { classNames } from '@egds/react-core/utils';
import { EGDSTextLoyaltyThemes } from '../types/index.esm.js';
import styles from '../../../../../styles/egds-lodging-text-loyalty-themes.css';

const getClassNameList = classNames.bind(styles);
const TextLoyaltyThemes = (props) => {
    const { children, align, dataTestId, wordBreak, theme, className, whiteSpace, weight, size, hyphens, overflow, spacing, inline, } = props;
    const textLoyaltyClassname = getClassNameList(`uitk-text-loyalty-${theme}`, className);
    const isLoyaltyTheme = theme &&
        (theme === EGDSTextLoyaltyThemes.LOW ||
            theme === EGDSTextLoyaltyThemes.HIGH ||
            theme === EGDSTextLoyaltyThemes.MID ||
            theme === EGDSTextLoyaltyThemes.EXTRAHIGH);
    return (jsx(EGDSText, { className: textLoyaltyClassname, align: align, dataTestId: dataTestId, wordBreak: wordBreak, whiteSpace: whiteSpace, weight: weight, size: size, hyphens: hyphens, overflow: overflow, spacing: spacing, inline: inline, theme: isLoyaltyTheme ? 'default' : theme, children: children }));
};
TextLoyaltyThemes.displayName = 'TextLoyaltyThemes';

export { TextLoyaltyThemes };
//# sourceMappingURL=index.esm.js.map
